import React from 'react'

import {
  Box,
  Text,
  Space,
  Icon,
  Display,
  Color,
  AlignItems,
  FontWeight,
  IconVariant,
} from '@gousto-internal/citrus-react'

import { signupConfig } from 'routes/Signup/signupConfig'

export const AccordionTitle = (isExpanded: boolean) => {
  const { accordionTitle: title } = signupConfig.boxSizePriceBreakdownStep

  return (
    <Box display={Display.Flex} alignItems={AlignItems.Center} paddingH={6}>
      <Text color={Color.Secondary_400} size={2} fontWeight={FontWeight.SemiBold}>
        {isExpanded ? `Hide ${title}` : `View ${title}`}
      </Text>
      <Space size={1} direction="horizontal" />
      <Icon name={isExpanded ? 'chevron_up' : 'chevron_down'} variant={IconVariant.Actionable} />
    </Box>
  )
}
